import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { VendaList } from '@/features/venda/page/list/VendaList';
import { useVendaPaginationStore } from '@/features/venda/store/useVendaPaginationStore';
import { VendaTipoSchema } from '@/features/venda/types/VendaTipo';

const ParamsSchema = z.object({
    tipo: VendaTipoSchema,
});

// biome-ignore assist/source/useSortedKeys: type inference
export const Route = createFileRoute('/a/venda/$tipo/')({
    params: {
        parse: (params) => {
            const result = ParamsSchema.safeParse(params);

            return result.success ? result.data : false;
        },
    },
    beforeLoad: (ctx) => {
        if (ctx.preload) {
            return;
        }

        const tipoParam = ctx.params.tipo;
        const tipoFilter = useVendaPaginationStore.getState().filter?.tipo;

        // Se não tem tipo na store, seta o tipo do param
        if (!tipoFilter) {
            useVendaPaginationStore.getState().setFilter({ tipo: tipoParam });
            return;
        }

        // Se o tipo na store for cancelado ou total, ignora
        if (tipoFilter === 'cancelado' || tipoFilter === 'total') {
            return;
        }

        // Se o tipo na store for diferente do param, seta o param
        if (tipoFilter !== tipoParam) {
            useVendaPaginationStore.getState().setFilter({ tipo: tipoParam });
        }
    },
    component: Component,
});

function Component() {
    const { tipo } = Route.useParams();

    return <VendaList tipo={tipo} />;
}
